import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/vercel/path0/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
